/**
 * Single source of truth for age groups (data lives in ageGroups.json so the
 * backend can render SEO tags for /shop-by-age/:slug from the same content).
 * `param` must match the Product model `ageGroup` enum on the backend.
 * `slug` powers the SEO landing pages at /shop-by-age/:slug.
 */
import AGE_GROUPS_DATA from './ageGroups.json';

export const AGE_GROUPS = AGE_GROUPS_DATA;

export const getAgeBySlug = (slug) => AGE_GROUPS.find(a => a.slug === slug);
export const getAgeByParam = (param) => AGE_GROUPS.find(a => a.param === param);
export const ageLink = (age) => `/shop-by-age/${age.slug}`;
// Static illustration generated by scripts/build-age-art.js
export const ageArt = (age) => `/images/ages/${age.slug}.svg`;
